import { useTooltipRebuild } from "hooks/useTooltipRebuild";
import React from "react";
import { Icon } from "rhombus-react";
import { useLocation } from "react-router";
import { LinkAction } from "widgets/ActionMenu";
import { useDispatch, useSelector } from "react-redux";
import { confirmDeleteQrDesign } from "reducers/Confirm";
import { API_URL, MODAL_TYPES } from "utils/constants";
import { downloadFile } from "reducers/Download";
import { openModal } from "reducers/Modal";
import { addNotification } from "reducers/Notifications";
import { getQrDesigns } from "reducers/QrDesigns";
import { hasPermission } from "utils/common";
import Permissioned from "widgets/Permissioned";

import "./QrCodesDesignsActions.css";

const commonLinkActionProps={
	useMenuItem:false,
	iconClass:"bounce-circle",
	className:"action-link",
};
const domain = "Creative View";
const action = "Upload Assets";

export function QrCodeDesignsActions({ dependentValues = {} }){
	let { numQrCodes, libraryId, id, designName } = dependentValues;
	const dispatch = useDispatch();
	const user = useSelector(state => state.you);
	const hasPermissionToAction = hasPermission(user, domain, action);

	function openDuplicateQrCodeDesignModal(){
		dispatch(openModal(MODAL_TYPES.DUPLICATE_QR_CODE_DESIGN, {
			designId: id,
			libraryId,
			initialValues: { name: `${designName} Copy` } }
		));
	}

	function onDeleteSuccess() {
		dispatch(getQrDesigns(libraryId));
	}

	function openDeleteCodeDesignModal(){
		dispatch(confirmDeleteQrDesign({ id, designName, onSuccess: onDeleteSuccess }));
	}

	const qrTip = "View QR Codes"
		, editTip = (numQrCodes === 0 && hasPermissionToAction) ? "Edit QR Design" : "View QR Design"
		, duplicateTip = "Duplicate QR Design"
		, deleteTip = "Delete QR Design";

	useTooltipRebuild(dependentValues);

	const qrLinkActionProps={
		...commonLinkActionProps,
		iconName:"far fa-qrcode",
		path:`/library/${libraryId}/qr-designs/${id}/codes/`,
		tooltipContent:qrTip,
	};

	const editActionProps = {
		...commonLinkActionProps,
		iconName: "far fa-pencil",
		path: `/library/${libraryId}/qr-designs/${id}/`,
		tooltipContent: editTip,
	};

	return (
		<div className="grid-actions preview-actions flex-center">
			<LinkAction key="qr-specs" {...qrLinkActionProps} />
			<LinkAction {...editActionProps} />
			<Permissioned key="qr-design-duplicate-and-delete" action={action} domain={domain}>
				<Icon data-tip={duplicateTip} name="far fa-clone" onClick={openDuplicateQrCodeDesignModal} className="qr-action" />
				{ numQrCodes === 0 && <Icon
					data-tip={deleteTip}
					name="far fa-trash-alt"
					onClick={openDeleteCodeDesignModal}
					className="qr-action" /> }
			</Permissioned>
		</div>
	);
}

export function QrCodesActions({ dependentValues = {} }) {
	let { id, imageUrl } = dependentValues;
	const dispatch = useDispatch();
	const { pathname: currentPath } = useLocation();
	const user = useSelector(state => state.you);
	const hasPermissionToAction = hasPermission(user, domain, action);

	function copyQrLink() {
		navigator.clipboard.writeText(imageUrl)
			.then(() => {
				dispatch(addNotification({
					type: "success",
					id: Math.random(),
					messageHeader: "Success!",
					message: `Copied QR code link to clipboard`,
				}));
			})
			.catch((err) => {
				console.error("Failed to copy QR Code link: ", err);
			});
	}

	useTooltipRebuild();

	const handleDownload = async () => {
		const fileName = imageUrl.split('/').pop();
		await dispatch(downloadFile(`${API_URL}/qrm/v1/qrcodes/${id}/download`, fileName));
	};

	const editTip = hasPermissionToAction ? "Edit QR Code" : "View QR Code"
		, duplicateTip = "Duplicate QR Code"
		, downloadTip = "Download QR Code"
		, copyLinkTip = "Copy QR Code Link";

	const editActionProps = {
		...commonLinkActionProps,
		iconName: "far fa-pencil",
		path: `${currentPath}modal/submit-qr-code/qr-code/${id}`,
		tooltipContent: editTip,
	};

	const duplicateActionProps = {
		...commonLinkActionProps,
		iconName: "far fa-clone",
		path: `${currentPath}modal/submit-qr-code/qr-code/${id}/duplicate/`,
		tooltipContent: duplicateTip,
	};

	return (
		<div className="grid-actions preview-actions flex-center">
			<LinkAction {...editActionProps} />
			<Permissioned key={"qr-code-duplicate"} action={action} domain={domain}>
				<LinkAction {...duplicateActionProps} />
			</Permissioned>
			<Icon data-tip={downloadTip} name="far fa-download" onClick={handleDownload} className="qr-action" />
			<Icon data-tip={copyLinkTip} name="far fa-link" onClick={copyQrLink} className="qr-action" />
		</div>
	);
}
